import { message } from 'antd'
import {
  activeCityForCityRequest,
  deActiveCityForCityRequest,
  getAllAvailableCities,
} from '../../RestServices/authService'
import {
  changeCity,
  citiesFailed,
  citiesLoading,
  citiesSuccessfull,
} from '../Actions/citiesActions'

export const getAllCities = (token) => async (dipsatch) => {
  dipsatch(citiesLoading())
  try {
    const response = await getAllAvailableCities(token)
    //citites fillter
    const { cities: RatesTable } = response
    
    const divisionGroups = {}
    const provincesSet = new Set()

    RatesTable.forEach(item => {
      const divisionKey = String(item.division || 'unknown').toLowerCase()
      const provinceKey = String(item.province || 'unknown').toLowerCase()

      provincesSet.add(provinceKey)

      if (!divisionGroups[divisionKey]) {
        divisionGroups[divisionKey] = {
          division: divisionKey,
          province: provinceKey,
          cities: [],
        }
      }
      divisionGroups[divisionKey].cities.push(item)
    })

    const ArrayList = Object.values(divisionGroups)
    const provices = Array.from(provincesSet)

    dipsatch(
      citiesSuccessfull({ cities: ArrayList, provices, allcities: RatesTable }),
    )

  } catch (err) {
    dipsatch(citiesFailed(err.message))
    if (err.response) {
      message.error(err.response.data.message)
    } else {
      message.error(err.message)
    }
  }
}

export const updateCityToactive =
  (id, data, token, cities, division, getCities) => async (dipsatch) => {
    dipsatch(citiesLoading())
    try {
      const response = await activeCityForCityRequest(id, data, token)
      //citites fillter
      const { city } = response.data
      const itemCity = cities.find((item) => String(item.division).toLowerCase() === city.division)
      let changedCity = itemCity.cities.find((item) => item._id === city._id)
      // let finalList = {};
      changedCity.activeForProduct = city.activeForProduct
      dipsatch(changeCity({ cities }))
      message.success('cities is added successfully')
      getCities && getCities()
    } catch (err) {
      dipsatch(citiesFailed(err.message))
      if (err.response) {
        message.error(err.response.data.message)
      } else {
        message.error(err.message)
      }
    }
  }

export const updateCityToInactive =
  (id, data, token, cities, division) => async (dipsatch) => {
    dipsatch(citiesLoading())
    try {
      const response = await deActiveCityForCityRequest(id, data, token)
      //citites fillter
      const { city } = response.data
      const itemCity = cities.find((item) => String(String(item.division).toLowerCase()).toLowerCase() === String(city.division).toLowerCase())
      let changedCity = itemCity.cities.find((item) => item._id === city._id)
      // let finalList = {};
      changedCity.activeForProduct = city.activeForProduct
      dipsatch(changeCity({ cities }))
    } catch (err) {
      dipsatch(citiesFailed(err.message))
      if (err.response) {
        message.error(err.response.data.message)
      } else {
        message.error(err.message)
      }
    }
  }
